var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 24,
    viewBox: "0 0 138 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_287_218",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.206055H23.8982V23.9999H0V0.206055Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_287_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72613 6.41869L0.00476074 24.0008H6.22873L7.75479 19.7818L9.49546 14.6859L6.72613 6.41869ZM14.8024 0.206543H9.14256L11.9019 7.97802L11.9052 7.96824L15.9922 19.7818L17.5478 24.0008H23.8934L14.8024 0.206543Z",
    fill: "#CC2D2D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4728 23.4615H37.8991L34.8854 19.184L31.8717 23.4615H26.298L32.0985 15.2305L26.4924 7.2588H32.0661L34.8854 11.2771L37.7047 7.2588H43.2784L37.6723 15.2305L43.4728 23.4615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9298 23.9152C46.1663 23.9152 42.3424 20.1885 42.3424 15.3601C42.3424 10.5317 46.1663 6.80513 50.9298 6.80513C55.6934 6.80513 59.5173 10.5317 59.5173 15.3601C59.5173 20.1885 55.6934 23.9152 50.9298 23.9152ZM50.9298 19.184C53.0362 19.184 54.6565 17.6609 54.6565 15.3601C54.6565 13.0594 53.0362 11.5363 50.9298 11.5363C48.8235 11.5363 47.2032 13.0594 47.2032 15.3601C47.2032 17.6609 48.8235 19.184 50.9298 19.184Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4415 6.80513C83.1681 6.80513 85.5985 9.46237 85.5985 13.513V23.4615H80.7377V13.9343C80.7377 12.314 79.96 11.2771 78.4045 11.2771C76.7843 11.2771 75.8769 12.4113 75.8769 14.3232V23.4615H71.0161V13.9343C71.0161 12.314 70.2384 11.2771 68.6829 11.2771C67.0627 11.2771 66.1553 12.4113 66.1553 14.3232V23.4615H61.2945V7.2588H66.1553V8.74945C66.9006 7.64767 68.3265 6.80513 70.4976 6.80513C72.4095 6.80513 73.8354 7.58286 74.7427 8.94388C75.6501 7.64767 77.1407 6.80513 79.4415 6.80513Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3796 5.83297C88.7917 5.83297 87.4631 4.50435 87.4631 2.91648C87.4631 1.32862 88.7917 0 90.3796 0C91.9674 0 93.2961 1.32862 93.2961 2.91648C93.2961 4.50435 91.9674 5.83297 90.3796 5.83297ZM87.9492 23.4615V7.2588H92.81V23.4615H87.9492Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.862 7.2588H110.723V23.4615H105.862V21.9384C104.987 23.1374 103.367 23.9152 101.228 23.9152C97.9549 23.9152 95.168 21.582 95.168 17.2072V7.2588H100.029V16.4943C100.029 18.5035 101.293 19.4432 102.848 19.4432C104.63 19.4432 105.862 18.4062 105.862 16.1055V7.2588Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.462 6.80513C135.189 6.80513 137.619 9.46237 137.619 13.513V23.4615H132.758V13.9343C132.758 12.314 131.981 11.2771 130.425 11.2771C128.805 11.2771 127.898 12.4113 127.898 14.3232V23.4615H123.037V13.9343C123.037 12.314 122.259 11.2771 120.704 11.2771C119.083 11.2771 118.176 12.4113 118.176 14.3232V23.4615H113.315V7.2588H118.176V8.74945C118.921 7.64767 120.347 6.80513 122.518 6.80513C124.43 6.80513 125.856 7.58286 126.763 8.94388C127.671 7.64767 129.161 6.80513 131.462 6.80513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogo);
export default __webpack_public_path__ + "static/media/navbar-logo.9efa7b92da8e69c72ed04a97eb6358e5.svg";
export { ForwardRef as ReactComponent };